import * as React from 'react';
import { registerDecorator } from '@avensia/excite-contentful/Document';
import { styled } from '@glitz/react';

registerDecorator(
  'code',
  styled<React.PropsWithChildren>(({ children }) => <Center>{children}</Center>),
);

const Center = styled.span({
  display: 'block',
  textAlign: 'center',
});
